import React from 'react';
import Style from './layout-header.less';
import BackImage from './header-back.svg';
import CloseImage from './header-close.svg';

interface HeaderProps {
    title: string;
    onClose: () => void;
    onBack?: () => void;
    showBack?: boolean;
}

const LayoutHeader: React.FC<HeaderProps> = ({ title, onBack, onClose, showBack }) => (
    <div className={Style.header}>
        <button className={Style['icon-button']} onClick={showBack ? onBack : undefined }>
            { showBack && <img src={BackImage}/> }
        </button>
        <h1 className={Style.title}>{title}</h1>
        <button className={Style['icon-button']} onClick={onClose}>
            <img src={CloseImage}/>
        </button>
    </div>
);

export default LayoutHeader;
